import { authHandlers } from "@/pages/Public/mocks/auth.handlers";

export const handlers = [...authHandlers];
